module.exports = __webpack_public_path__ + "static/media/blog4_big.5dac3542.webp";